export default {"src":"/_next/static/image/public/images/menu_left_arrow_black.5be5cc15a3fb3a237cd2006147d20d7b.svg","height":14,"width":8};